import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GroupPicker } from '@work4all/components/lib/components/entity-picker/GroupPicker';
import { useSalesOpportunityGroups } from '@work4all/components/lib/components/entity-picker/sales-opportunities-group-picker/useSalesOpportunityGroups';

import { Group } from '@work4all/models/lib/Classes/Group.entity';
import { SalesOpportunityGroup } from '@work4all/models/lib/Classes/SalesOpportunityGroup.entity';

export interface SalesOpportunitiesGroupPickerProps {
  value: Group | Group[] | null;
  onChange: (value: SalesOpportunityGroup[]) => void;
  multiple?: boolean;
}

export function SalesOpportunitiesGroupPicker(
  props: SalesOpportunitiesGroupPickerProps
) {
  const { value, onChange, multiple } = props;
  const { t } = useTranslation();

  const response = useSalesOpportunityGroups();

  const groupsWithNone = useMemo(() => {
    const groups =
      response.data?.map((item) => ({
        name: item.name,
        id: item.id.toString(),
        index: item.index + 1,
        parentId: item.parentCode,
      })) ?? [];

    const noneGroup = {
      id: '0',
      name: t('COMMON.NONE'),
      index: 0,
      parentId: 0,
    };

    return [noneGroup, ...groups];
  }, [response.data, t]);

  return (
    <GroupPicker
      {...props}
      value={
        Array.isArray(value)
          ? value?.map((item) => ({
              ...item,
              id: item.id?.toString(),
              parentId: 0,
            }))
          : value
          ? [{ ...value, id: value.id?.toString(), parentId: 0 }]
          : null
      }
      onChange={(e) => {
        onChange(
          e.map((item) => ({ name: item.name, id: parseInt(item.id || '0') }))
        );
      }}
      groups={groupsWithNone}
      multiple={multiple}
    />
  );
}
